/**
 * Perxel - Global JS Entry
 *
 * Convention:
 * - This file is an entrypoint because it ends with `.entry.ts`.
 * - It will be built to `assets/js/index.js` and enqueued globally by PHP.
 */

// Example npm imports (bundled into `index.js`):
// import gsap from 'gsap';

import {createDataToggle} from '@phucbm/data-toggle';
import {initHeader} from '../../components/header/header';
import {initFloatingContact} from '../../components/floating-contact/floating-contact';
import {initLenis} from './lenis';
import {initFadeIn} from './fade-in';
import {initFullscreenScroll} from './fullscreen-scroll';
// Easy Select: every select[data-easy-select] on load (the post list's category dropdown from tablet-v).
// Docs: https://github.com/viivue/easy-select
import '@viivue/easy-select';

// One instance for every [data-toggle] on the page (classes on <html>, aria-expanded kept in step,
// Escape closes triggers with data-toggle-escape). Docs: https://github.com/phucbm/data-toggle
const toggle = createDataToggle({aria: true});

initHeader(toggle);

// Shared motion (hung-hola): Lenis smooth scroll and the data-px-fade-in reveal (GSAP from Nectar, handle "gsap").
initLenis();
initFadeIn();
initFloatingContact();
// Back to the video's place after its full screen (round 2 #4: Android in-app browsers jumped to the top).
initFullscreenScroll();

/**
 * Fix: nav menu links require two taps on touch screens.
 * The first tap triggers CSS :hover, the second tap follows the link.
 * Solution: on touchend, if the finger didn't scroll, navigate immediately.
 */
function fixNavMenuTouchLinks(selector = '.nav-menu li a'): void {
    let startY = 0;

    document.addEventListener('touchstart', (e) => {
        startY = e.touches[0].clientY;
    }, {passive: true});

    document.addEventListener('touchend', (e) => {
        const a = (e.target as Element).closest<HTMLAnchorElement>(selector);
        if (!a || !a.href) return;

        const movedY = Math.abs(e.changedTouches[0].clientY - startY);
        if (movedY > 10) return; // user was scrolling, not tapping

        e.preventDefault();
        window.location.href = a.href;
    });
}

fixNavMenuTouchLinks();

/**
 * Back to top: any element with [data-btt] scrolls the page to the top.
 */
document.querySelectorAll('[data-btt]').forEach(item => {
    item.addEventListener('click', (e) => {
        e.preventDefault();

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
});
